import React, { useRef } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import type { TabGroupProps } from '../types';
import { TabContextProvider } from '../TabContext';

const TabGroup = ({
  defaultIndex = 0,
  selectedIndex,
  onChange,
  variant = 'default',
  placement = 'top',
  isStretched = false,
  isLazy = false,
  autoSelect = true,
  size = 'md',
  children,
  onAnimationEnd,
  ...props
}: TabGroupProps) => {
  const tabGroupRef = useRef<HTMLDivElement>(null);

  return (
    <Stack
      ref={tabGroupRef}
      direction={placement === 'top' || placement === 'bottom' ? 'column' : 'row'}
      gap="0"
      position="relative"
      {...props}
    >
      <TabContextProvider
        defaultIndex={defaultIndex}
        selectedIndex={selectedIndex}
        onChange={onChange}
        onAnimationEnd={onAnimationEnd}
        variant={variant}
        placement={placement}
        isStretched={isStretched}
        isLazy={isLazy}
        autoSelect={autoSelect}
        tabGroupRef={tabGroupRef}
        size={size}
      >
        {children}
      </TabContextProvider>
    </Stack>
  );
};

TabGroup.displayName = 'TabGroup';

export default TabGroup;
